export default {
  methods: {
    setupCookie (token) {
      document.cookie = `access_token=${token}; path=/; secure`
    }
  }
}
